var map = {
	"./activity/activity.module": [
		"./src/app/activity/activity.module.ts",
		"common",
		"activity.module"
	],
	"./assetmgmt/assetmgmt.module": [
		"./src/app/assetmgmt/assetmgmt.module.ts",
		"common",
		"assetmgmt.module"
	],
	"./calendar/calendar.module": [
		"./src/app/calendar/calendar.module.ts",
		"common",
		"calendar.module"
	],
	"./cards/cards.module": [
		"./src/app/cards/cards.module.ts",
		"common",
		"cards.module"
	],
	"./charts/charts.module": [
		"./src/app/charts/charts.module.ts",
		"common",
		"charts.module"
	],
	"./chat-ngrx/chat-ngrx.module": [
		"./src/app/chat-ngrx/chat-ngrx.module.ts",
		"common",
		"chat-ngrx.module"
	],
	"./chat/chat.module": [
		"./src/app/chat/chat.module.ts",
		"common",
		"chat.module"
	],
	"./color-palette/color-palette.module": [
		"./src/app/color-palette/color-palette.module.ts",
		"color-palette.module"
	],
	"./compliance/compliance.module": [
		"./src/app/compliance/compliance.module.ts",
		"common",
		"compliance.module"
	],
	"./components/ui-components.module": [
		"./src/app/components/ui-components.module.ts",
		"common",
		"ui-components.module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./data-tables/data-tables.module": [
		"./src/app/data-tables/data-tables.module.ts",
		"common",
		"data-tables.module"
	],
	"./forms/forms.module": [
		"./src/app/forms/forms.module.ts",
		"common",
		"forms.module"
	],
	"./inbox/inbox.module": [
		"./src/app/inbox/inbox.module.ts",
		"common",
		"inbox.module"
	],
	"./maps/maps.module": [
		"./src/app/maps/maps.module.ts",
		"maps.module"
	],
	"./ngx-wizard/ngx-wizard.module": [
		"./src/app/forms/ngx-wizard/ngx-wizard.module.ts",
		"common"
	],
	"./pages/content-pages/content-pages.module": [
		"./src/app/pages/content-pages/content-pages.module.ts",
		"common",
		"content-pages.module"
	],
	"./pages/full-pages/full-pages.module": [
		"./src/app/pages/full-pages/full-pages.module.ts",
		"common",
		"full-pages.module"
	],
	"./player/player.module": [
		"./src/app/player/player.module.ts",
		"common",
		"player.module"
	],
	"./tables/tables.module": [
		"./src/app/tables/tables.module.ts",
		"common",
		"tables.module"
	],
	"./taskboard-ngrx/taskboard-ngrx.module": [
		"./src/app/taskboard-ngrx/taskboard-ngrx.module.ts",
		"common",
		"taskboard-ngrx.module"
	],
	"./taskboard/taskboard.module": [
		"./src/app/taskboard/taskboard.module.ts",
		"common",
		"taskboard.module"
	],
	"./ui-kit/ui-kit.module": [
		"./src/app/ui-kit/ui-kit.module.ts",
		"common",
		"ui-kit.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main